import { VALIDATE_SESSION } from 'constants/header';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const sessionReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${VALIDATE_SESSION}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${VALIDATE_SESSION}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${VALIDATE_SESSION}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
